<template>
  <div class="header" id="header">
    <div class="back" @click="back">
      <i class="iconfont">&#xe604;</i>
    </div>
    <!-- <div class="search">
      <div class="search-box">
        <i class="iconfont">&#xe706;</i>
        <input type="text" placeholder="请输入您要搜索的商品" v-model="search">
      </div>
    </div>
    <div class="search-font">
      <button type="submit" @click="handleSearchClick">{{state}}</button>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'BusinessHeader',
  data () {
    return {
      state: '搜索',
      search: ''
    }
  },
  methods: {
    back () {
      this.$router.go(-1) // 返回上一层
    }
    // handleSearchClick () {
    //   this.state = '搜索中...'
    //   this.bus.$emit('loading', true)
    //   this.searchresult()
    //   // 反馈
    // },
    // // 验证
    // searchresult () {
    //   this.axios.post('http://kukucode.zhinengpingtai.com/apimember/login', {
    //     search: this.search
    //   }).then(this.postSearInfoSucc)
    //     .catch(this.postSearInfoFail)
    // },
    // // 提交
    // postSearInfoSucc (res) {
    //   this.state = '搜索'
    //   res = res.data
    //   if (res.ret && res.okInfo === 'succeed') {
    //     alert('搜索成功')
    //     this.$router.push({
    //       path: '/'
    //     })
    //   }
    // },
    // postSearInfoFail () {
    //   alert('搜索失败')
    // }
  }
}
</script>

<style scoped>
.header{ display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #f2f2f2; padding: 10px 15px;}
.back a{ text-decoration: none; color: #333;}
.back .iconfont{ font-size: 25px;}
.search-font button{ color: #9f9e9e; border: 0; background: transparent; font-family: Arial,"Microsoft YaHei";}
.search-box{ display: flex; justify-content: space-around; background-color: #efefef; border-radius: 3px;}
.search input{ width: 240px; border: 0; border-radius: 3px; background-color: #efefef;}
input::-webkit-input-placeholder{ color:#7f7f7f; font-size: 13px; line-height: 15px; font-family: Arial,"Microsoft YaHei";}
.search .iconfont{ line-height: 32px; margin: 0 8px; font-size: 14px;}
.back{ width: 7%;}
.search{ width: 78%;}
.search-font{ width: 9%;}
</style>



// WEBPACK FOOTER //
// src/pages/platform_goods/components/Header.vue